import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useEventStore = defineStore('event', () => {
    const events = ref([]);
    const categories = ref([]);
    
    const categoriesToFilter = ref([]);
    const placeToFilter = ref("");
    const regionToFilter = ref("");
    const dateToFilter = ref([]);
    const pricesToFilter = ref([]);
    
    const getPlaces = computed(() => {
        return [...new Set(events.value.map(event => event.place))].sort();
    });
    
    const getRegions = computed(() => {
        return [...new Set(events.value.map(event => event.region))].sort();
    });
    
    const getMaxPrice = computed(() => {
        return Math.max(...events.value.map(event => event.price));
    })
    

    const loadEvents = async () => {
        const response = await fetch("/resources/webcomponents/src/assets/events.json");
        const loadedEvents = await response.json();        
        events.value = [...loadedEvents];

        const duplicateCategories = ref([]);
        loadedEvents.forEach(event => {
            event.categories.forEach(category => {
                duplicateCategories.value.push(category);
            })
        })
        categories.value = [...new Set(duplicateCategories.value)];
    };

    const resetFilter = () => {
        categoriesToFilter.value = [];
        placeToFilter.value = "";
        regionToFilter.value = "";
        dateToFilter.value = [];
        pricesToFilter.value = [];
    };
    
    const filteredEvents = computed(() => {
        let filtered = events.value

        // Kategorie filtern
        if (categoriesToFilter.value.length > 0) {
            filtered = filtered.filter(event => {
                let isIncluded = false;
                event.categories.forEach(category => {
                    if (categoriesToFilter.value.includes(category)){
                        isIncluded = true;
                    }
                })
                return isIncluded;
            })
        }
    
        // Datum filtern
        if (Array.isArray(dateToFilter.value) && dateToFilter.value.length === 2) {
            const [start, end] = dateToFilter.value;
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            filtered = filtered.filter(event => {
                const [startDay, startMonth, startYear] = event.startDate.split('.');
                const compareStartDate = new Date(`${startYear}-${startMonth}-${startDay}`);
                const [endDay, endMonth, endYear] = event.endDate.split('.');
                const compareEndDate = new Date(`${endYear}-${endMonth}-${endDay}`);
                return (compareStartDate >= start && compareStartDate <= end) || (compareEndDate >= start && compareEndDate <= end) || (compareStartDate <= start && compareEndDate >= end);
            });
        }
    
        // Veranstaltungsort filtern
        if (placeToFilter.value) {
            filtered = filtered.filter(event => event.place === placeToFilter.value);
        }

        // Regionalstelle filtern
        if (regionToFilter.value) {
            filtered = filtered.filter(event => event.region === regionToFilter.value);
        }

        // Preis filtern
        if (Array.isArray(pricesToFilter.value) && pricesToFilter.value.length === 2) {
            filtered = filtered.filter(event => event.price >= pricesToFilter.value[0] && event.price <= pricesToFilter.value[1]);
        }
    
        return filtered;
    });

    return {
        events,
        categories,
        categoriesToFilter: categoriesToFilter,
        placeToFilter,
        regionToFilter,
        dateToFilter,
        pricesToFilter,
        getPlaces,
        getRegions,
        getMaxPrice,
        loadEvents,
        resetFilter,
        filteredEvents,
    };
});
